<template>
  <div class="dg-detail">
    <Toast :style="{ width: $isMobile() ? '85vw' : '' }" />

    <div class="dg-detail__header">
      <div class="dg-detail__title">
        <h4 class="p-m-0">
          <i class="pi pi-globe p-mr-2" />Extranet
        </h4>
        <small class="p-text-secondary">
          Ordem de serviço proveniente do portal Extranet.
        </small>
      </div>
    </div>

    <TabView>
      <!-- Detalhes -->
      <TabPanel header="Detalhes">
        <Fieldset legend="Identificação" class="dg-fieldset">
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-6 p-lg-3" v-if="serviceOrder.patId">
              <label for="pat_id">PAT</label>
              <InputText id="pat_id" type="text" v-model="serviceOrder.patId" :disabled="true" />
            </div>
            <div class="p-field p-col-12 p-md-6 p-lg-3">
              <label for="id">Ordem de Serviço</label>
              <InputText id="id" type="text" v-model="serviceOrder.id" :disabled="true" />
            </div>
            <div class="p-field p-col-12 p-md-6 p-lg-3">
              <label for="created_at">Data da Solicitação</label>
              <InputText id="created_at" type="text" v-model="serviceOrder.created_at" :disabled="true" />
            </div>
            <div class="p-field p-col-12" v-if="serviceOrder.problem">
              <label for="problem">Problema</label>
              <Textarea id="problem" :autoResize="true" v-model="serviceOrder.problem" :disabled="true" />
            </div>
            <div class="p-field p-col-12" v-if="serviceOrder.description">
              <label for="description">Descrição</label>
              <Textarea id="description" :autoResize="true" v-model="serviceOrder.description" :disabled="true" />
            </div>
          </div>
        </Fieldset>

        <!-- Cliente -->
        <Fieldset
          v-if="serviceOrder.client"
          legend="Cliente"
          class="dg-fieldset"
          :toggleable="true"
        >
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-6 p-lg-4">
              <label for="client_name">Nome</label>
              <InputText id="client_name" type="text" v-model="serviceOrder.client.name" :disabled="true" />
            </div>
            <div class="p-field p-col-12 p-md-6 p-lg-4" v-if="serviceOrder.client.email">
              <label for="client_email">Email</label>
              <InputText id="client_email" type="text" v-model="serviceOrder.client.email" :disabled="true" />
            </div>
            <div class="p-field p-col-12 p-md-6 p-lg-2" v-if="serviceOrder.client.telephone">
              <label for="client_telephone">Contacto 1</label>
              <InputText id="client_telephone" type="text" v-model="serviceOrder.client.telephone" :disabled="true" />
            </div>
            <div class="p-field p-col-12 p-md-6 p-lg-2" v-if="serviceOrder.client.mobilPhone">
              <label for="client_mobile">Contacto 2</label>
              <InputText id="client_mobile" type="text" v-model="serviceOrder.client.mobilPhone" :disabled="true" />
            </div>
            <div class="p-field p-col-12 p-md-6" v-if="serviceOrder.client.address">
              <label for="client_address">Morada</label>
              <InputText id="client_address" type="text" v-model="serviceOrder.client.address" :disabled="true" />
            </div>
            <div class="p-field p-col-12 p-md-3 p-lg-2" v-if="serviceOrder.client.zipCode">
              <label for="client_zip">Código Postal</label>
              <InputText id="client_zip" type="text" v-model="serviceOrder.client.zipCode" :disabled="true" />
            </div>
            <div class="p-field p-col-12 p-md-3 p-lg-2" v-if="serviceOrder.client.city">
              <label for="client_city">Cidade</label>
              <InputText id="client_city" type="text" v-model="serviceOrder.client.city" :disabled="true" />
            </div>
          </div>
        </Fieldset>

        <!-- Entidade -->
        <Fieldset
          v-if="serviceOrder.entity"
          legend="Entidade"
          class="dg-fieldset"
          :toggleable="true"
        >
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-6 p-lg-4" v-if="serviceOrder.entity.name">
              <label for="entity_name">Nome</label>
              <InputText id="entity_name" type="text" v-model="serviceOrder.entity.name" :disabled="true" />
            </div>
            <div class="p-field p-col-12 p-md-6 p-lg-4" v-if="serviceOrder.entity.email">
              <label for="entity_email">Email</label>
              <InputText id="entity_email" type="text" v-model="serviceOrder.entity.email" :disabled="true" />
            </div>
            <div class="p-field p-col-12 p-md-6 p-lg-2" v-if="serviceOrder.entity.telephone">
              <label for="entity_tel">Contacto 1</label>
              <InputText id="entity_tel" type="text" v-model="serviceOrder.entity.telephone" :disabled="true" />
            </div>
            <div class="p-field p-col-12 p-md-6 p-lg-2" v-if="serviceOrder.entity.mobile">
              <label for="entity_mobile">Contacto 2</label>
              <InputText id="entity_mobile" type="text" v-model="serviceOrder.entity.mobile" :disabled="true" />
            </div>
            <div class="p-field p-col-12 p-md-6" v-if="serviceOrder.entity.address">
              <label for="entity_address">Morada</label>
              <InputText id="entity_address" type="text" v-model="serviceOrder.entity.address" :disabled="true" />
            </div>
            <div class="p-field p-col-12 p-md-3 p-lg-2" v-if="serviceOrder.entity.zip_code">
              <label for="entity_zip">Código Postal</label>
              <InputText id="entity_zip" type="text" v-model="serviceOrder.entity.zip_code" :disabled="true" />
            </div>
            <div class="p-field p-col-12 p-md-3 p-lg-2" v-if="serviceOrder.entity.city">
              <label for="entity_city">Cidade</label>
              <InputText id="entity_city" type="text" v-model="serviceOrder.entity.city" :disabled="true" />
            </div>
            <div class="p-field p-col-12 p-md-3 p-lg-2" v-if="serviceOrder.entity.nif">
              <label for="entity_nif">NIF</label>
              <InputText id="entity_nif" type="text" v-model="serviceOrder.entity.nif" :disabled="true" />
            </div>
          </div>
        </Fieldset>

        <!-- Equipamento -->
        <Fieldset
          v-if="serviceOrder.equipment"
          legend="Equipamento"
          class="dg-fieldset"
          :toggleable="true"
        >
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-6 p-lg-3" v-if="serviceOrder.equipment.brand">
              <label for="eq_brand">Marca</label>
              <InputText id="eq_brand" type="text" v-model="serviceOrder.equipment.brand" :disabled="true" />
            </div>
            <div class="p-field p-col-12 p-md-6 p-lg-3" v-if="serviceOrder.equipment.model">
              <label for="eq_model">Modelo</label>
              <InputText id="eq_model" type="text" v-model="serviceOrder.equipment.model" :disabled="true" />
            </div>
            <div class="p-field p-col-12 p-md-6 p-lg-3" v-if="serviceOrder.equipment.type">
              <label for="eq_type">Tipo</label>
              <InputText id="eq_type" type="text" v-model="serviceOrder.equipment.type" :disabled="true" />
            </div>
            <div class="p-field p-col-12 p-md-6 p-lg-3" v-if="serviceOrder.equipment.serialNumber">
              <label for="eq_serial">Número de Série</label>
              <InputText id="eq_serial" type="text" v-model="serviceOrder.equipment.serialNumber" :disabled="true" />
            </div>
          </div>
        </Fieldset>
      </TabPanel>
    </TabView>
  </div>
</template>

<script>
import TabPanel from "primevue/tabpanel";
import TabView from "primevue/tabview";
import Fieldset from "primevue/fieldset";

export default {
  name: "PatDetailExtranet",
  props: ["serviceOrder"],
  components: {
    TabView,
    TabPanel,
    Fieldset,
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {},
};
</script>

<style scoped>
.dg-detail {
  padding: 0.5rem 0;
}

.dg-detail__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 1rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid var(--surface-border, #dee2e6);
}

.dg-detail__title h4 {
  color: var(--text-color, #495057);
}

.dg-fieldset {
  margin-bottom: 1.25rem;
}

.dg-fieldset ::v-deep(.p-fieldset-legend) {
  font-weight: 600;
  font-size: 0.95rem;
}

.dg-fieldset ::v-deep(.p-fieldset-content) {
  padding: 1rem 0.5rem 0.5rem;
}

.dg-fieldset .p-field {
  margin-bottom: 1rem;
}

.dg-fieldset .p-field label {
  display: block;
  margin-bottom: 0.35rem;
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--text-color-secondary, #6c757d);
}
</style>
